import { render, staticRenderFns } from "./EditEvent.vue?vue&type=template&id=49cc15cb&scoped=true&lang=pug"
import script from "./EditEvent.vue?vue&type=script&lang=js"
export * from "./EditEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cc15cb",
  null
  
)

export default component.exports